import {useCallback, useMemo, useState} from 'react';
import {Dialog} from '../design-system/organisms/Dialog';
import {DialogProps} from '../design-system/organisms/Dialog/DialogProps.interface';

export function useDialog({
  isMobile,
  isShadow = false,
  openWhenMount = false,
  onClose,
}: {
  isMobile: boolean;
  isShadow?: boolean;
  openWhenMount?: boolean;
  onClose?: () => void;
}) {
  const [isOpen, setIsOpen] = useState(openWhenMount);
  const showDialog = useCallback(() => {
    setIsOpen(true);
  }, []);

  const hideDialog = useCallback(() => {
    setIsOpen(false);
    onClose?.();
  }, [onClose]);

  const DialogWrapper = useMemo(() => {
    const DialogComponent: React.FC<
      Omit<DialogProps, 'isOpen' | 'onClose'>
    > = ({children, ...props}) => {
      return (
        <Dialog
          isOpen={isOpen}
          isMobile={isMobile}
          isShadow={isShadow}
          onClose={hideDialog}
          {...props}
        >
          {children}
        </Dialog>
      );
    };
    return DialogComponent;
  }, [isOpen, isMobile, isShadow, hideDialog]);

  return {
    Dialog,
    DialogWrapper,
    showDialog,
    hideDialog,
    isOpen,
  };
}
